import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: loadUser(),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, data) => {
      localStorage.setItem('access_token', data.payload.accessToken);
      localStorage.setItem('refresh_token', data.payload.refreshToken);
      state.user = data.payload.user;
      localStorage.setItem('user', JSON.stringify(data.payload.user));
    },
    logout: (state) => {
      state.user = null;
      localStorage.removeItem('user');
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
    },
    refresh_token: (state, data) => {
      localStorage.setItem('access_token', data.payload.accessToken);
      localStorage.setItem('refresh_token', data.payload.refreshToken);
    },
    updateUser: (state, action) => {
      if (!state.user) {
        return;
      }
      state.user = { ...state.user, ...action.payload };
      localStorage.setItem('user', JSON.stringify(state.user));
    },
  },
});

function loadUser() {
  try {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  } catch (e) {
    console.error("Error when parsing user from localStorage:", e);
    return null;
  }
}

export const { login, logout, refresh_token, updateUser } = authSlice.actions;
export default authSlice.reducer;